<template>
  <section class="page-otcOrder">
    <div class="otcOrder-nav a-3-bd">
      <c-navTab
        activeClassName="b-2-cl"
        activeColor="a-12-bg"
        className="b-2-cl"
        :currentTab="nowType"
        :navTab="navTab"
        lineHeight="55"
        @currentType="currentType"
      />
      <!-- 显示已撤单 -->
      <div class="otcOrder-nav-switchs" v-if="nowType === 2">
        <c-checkBox :value="switchFlag" @click="switchChange"/>
        <span class="text">{{ $t('order.otcOrder.haveCancel') }}</span>
      </div>
    </div>
    <div class="otcOrder-options">
      <!-- :promptText="$t('order.otcOrder.coin')" -->
      <c-select
        :value="symbol"
        :options="symbolList"
        :errorHave="true"
        width="120px"
        :filterable="true"
        newStyleFormat
        fill
        size="small"
        @onChanges="symbolChange"/>
      <!-- <c-select
        v-if="nowType === 2"
        :value="status"
        :options="statusList"
        :errorHave="true"
        width="120px"
        :filterable="true"
        newStyleFormat
        fill
        size="small"
        @onChanges="statusChange"/> -->
    </div>
     <div class="otcOrder-table">
      <c-table
        :imgMap="imgMap"
        :colorMap="colorMap"
        :loading="tabelLoading"
        :columns="columns"
        :dataList="tabelList"
        @elementClick="tableClick"
      />
      <c-pagination v-if="paginationObj.total > paginationObj.display"
        :total='paginationObj.total'
        :display='paginationObj.display'
        :currentPage='paginationObj.currentPage'
        @pagechange="pagechange"/>
    </div>
  </section>
</template>

<script>
import {
  imgMap, colorMap, fixD, getCoinShowName,
} from '@/utils';

export default {
  name: 'page-otcOrder',
  data() {
    return {
      imgMap,
      colorMap,
      switchFlag: false,
      tabelLoading: true,
      tabelList: [],
      nowType: 1, // 1为当前委托 2为历史委托
      symbol: 'all', // 当前币种
      symbolList: [
        {
          code: 'all',
          value: this.$t('order.otcOrder.allCoin'),
        },
      ], // 币种选择列表
      side: 'all', // 方向
      paginationObj: {
        total: 0, // 数据总条数
        display: 10, // 每页显示条数
        currentPage: 1, // 当前页码
      },
      status: 'all', // 当前状态
      statusList: [
        {
          code: 'all',
          value: this.$t('order.otcOrder.allCoin'),
        },
      ],
    };
  },
  watch: {
    market(v) { if (v) { this.initSymbolList(); } },
  },
  computed: {
    linkurl() {
      if (this.$store.state.baseData.publicInfo) {
        return this.$store.state.baseData.publicInfo.url;
      }
      return {};
    },
    excheifFlag() {
      return this.$store.state.baseData.exchief_project_switch;
    },
    navTab() {
      return [
        // 当前委托
        { name: this.$t('order.otcOrder.nowOrder'), index: 1 },
        // 历史委托
        { name: this.$t('order.otcOrder.hisOrder'), index: 2 },
      ];
    },
    sideList() {
      return [ // 方向选择列表
        // 全部
        { code: 'all', value: this.$t('order.otcOrder.all') },
        // 买入
        { code: 'buy', value: this.$t('order.otcOrder.buy') },
        // 卖出
        { code: 'sell', value: this.$t('order.otcOrder.sell') },
      ];
    },
    market() { return this.$store.state.baseData.market; },
    axiosSide() {
      if (this.side === 'all') {
        return '';
      }
      return this.side;
    },
    axiosSymbol() {
      if (this.symbol === 'all') {
        return undefined;
      }
      return this.symbol;
    },
    axiosStatus() {
      if (this.status === 'all') {
        return undefined;
      }
      return this.status;
    },
    // 表格title
    columns() {
      let list = [];
      if (this.nowType === 1) {
        list = [
          { title: this.$t('order.otcOrder.nowOrderId'), width: '120px' }, // 订单号
          { title: this.$t('order.otcOrder.nowOrderType') }, // 类别
          { title: this.$t('order.otcOrder.nowOrderCoin') }, // 币种
          { title: this.$t('order.otcOrder.nowOrderPirce') }, // 价格
          { title: this.$t('order.otcOrder.nowOrderVolume') }, // 数量
          { title: this.$t('order.otcOrder.nowOrderTotol') }, // 交易额
          { title: this.$t('order.otcOrder.service') }, // 手续费
          { title: this.$t('order.otcOrder.nowOrderStatus'), width: '170px' }, // 状态
          { title: this.$t('order.otcOrder.nowOrderUser'), width: '120px', align: 'center' }, // 交易方
        ];
      } if (this.nowType === 2) {
        list = [
          { title: this.$t('order.otcOrder.hisOrderId'), width: '120px' }, // 订单号
          { title: this.$t('order.otcOrder.hisOrderType') }, // 类别
          { title: this.$t('order.otcOrder.hisOrderCoin') }, // 币种
          { title: this.$t('order.otcOrder.hisOrderPirce') }, // 价格
          { title: this.$t('order.otcOrder.hisOrderVolume') }, // 数量
          { title: this.$t('order.otcOrder.hisOrderTotol') }, // 交易额
          { title: this.$t('order.otcOrder.service') }, // 手续费
          { title: this.$t('order.otcOrder.hisOrderStatus'), width: '170px' }, // 状态
          { title: this.$t('order.otcOrder.hisOrderUser'), width: '120px', align: 'center' }, // 交易方
        ];
      }
      if (!this.excheifFlag) {
        list.forEach((item, i) => {
          if (item.title === this.$t('order.otcOrder.service')) {
            list.splice(i, 1);
          }
        });
      }
      return list;
    },
    baseData() { return this.$store.state.baseData; },
  },
  mounted() {
    this.init();
  },
  methods: {
    getFix(coin) {
      return this.market.coinList[coin.toLocaleUpperCase()].showPrecision;
    },
    currentCoinPriceFix(price, coin, payCoin) {
      let fix = this.$store.state.baseData.defaultFiatPrecision;
      if (payCoin
          && this.market
          && this.market.coinList[coin]
          && this.market.coinList[coin].fiatPrecision
          && this.market.coinList[coin].fiatPrecision[payCoin.toLowerCase()]) {
        fix = this.market.coinList[coin].fiatPrecision[payCoin.toLowerCase()];
        return fixD(price, fix) + payCoin;
      }
      return fixD(price, 2) + payCoin;
    },
    init() {
      this.getStatus();
      if (this.market) { this.initSymbolList(); }
    },
    switchChange() {
      this.switchFlag = !this.switchFlag;
      this.getData();
    },
    initSymbolList() {
      const { coinList } = this.market;
      const list = [{
        code: 'all',
        value: this.$t('order.otcOrder.allCoin'),
      }];
      Object.keys(coinList).forEach((item) => {
        if (coinList[item].otcOpen) {
          list.push({ code: item, value: getCoinShowName(item, coinList) });
        }
      });
      // this.symbol = 'all';
      this.symbolList = list;
      if (list.length) { this.symbol = list[0].code; }
      this.getData();
    },
    getData() {
      if (this.nowType === 1) {
        this.getNowData();
      } else if (this.nowType === 2) {
        this.getHisData();
      }
    },
    // 获取当前
    getNowData() {
      const url = 'order/otc/unfinished';
      this.axios({
        url,
        method: 'post',
        params: {
          // side: this.axiosSide,
          pageSize: this.paginationObj.display, // 每页条数
          page: this.paginationObj.currentPage, // 页码
          coinSymbol: this.axiosSymbol,
        },
      }).then((data) => {
        if (this.nowType !== 1) return;
        this.tabelLoading = false;
        if (data.code.toString() === '0') {
          const list = [];
          data.data.orderList.forEach((item) => {
            let Aurl = `/otcDetailOrder?orderId=${item.sequence}`;
            let block = '';
            if (item.orderType) {
              Aurl = item.url;
              block = 'target="view_frame"';
            }
            let Flist = [
              // 订单号
              [{
                // type: 'link', text: item.sequence, eventType: 'orderId', classes: ['orderId'],
                type: 'icon', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                iconSvg: `<a class="blue-cl" ${block} href="${Aurl}">${item.sequence}</a>`,
              }],
              [{
                text: item.type,
                classes: item.side === 'BUY' ? 'b-5-cl' : 'b-6-cl',
              }],
              getCoinShowName(item.coinSymbol, this.market.coinList), // 币种
              this.currentCoinPriceFix(item.price, item.coinSymbol, item.paycoin), // 价格
              fixD(item.volume, this.getFix(item.coinSymbol)), // 数量
              this.currentCoinPriceFix(item.totalPrice, item.coinSymbol, item.paycoin), // 交易额
            ];
            if (this.excheifFlag) {
              Flist.push(item.relativeFee);
            }
            const Vlist = [
              item.status_text, // 状态
              // 交易对方
              item.orderType
                ? item.realName
                : [
                  {
                    type: 'html',
                    text: `<a
                      class="blue-cl"
                      style="margin-bottom: 4px;
                      width: 120px;
                      display: inline-block;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;"
                      href="javascript:;" title="${item.nickName}">
                      ${item.nickName}</a>`,
                    eventType: 'userName',
                    subContent: {
                      text: item.realName,
                      classes: ['main-cl'], // 默认没有
                    },
                  },
                ],
            ];
            Flist = Flist.concat(Vlist);
            list.push({
              id: JSON.stringify(item),
              data: Flist,
            });
          });
          this.tabelList = list;
          this.paginationObj.total = data.data.count;
        }
      });
    },
    // 获取历史订单
    getHisData() {
      const url = 'order/otc/complete';
      this.axios({
        url,
        method: 'post',
        params: {
          // side: this.axiosSide,
          isShowCanceled: this.switchFlag ? 1 : 0,
          pageSize: this.paginationObj.display, // 每页条数
          page: this.paginationObj.currentPage, // 页码
          coinSymbol: this.axiosSymbol,
          status: this.axiosStatus,
        },
      }).then((data) => {
        if (this.nowType !== 2) return;
        this.tabelLoading = false;
        if (data.code.toString() === '0') {
          const list = [];
          data.data.orderList.forEach((item) => {
            let Aurl = `/otcDetailOrder?orderId=${item.sequence}`;
            let block = '';
            if (item.orderType) {
              Aurl = item.url;
              block = 'target="view_frame"';
            }
            let flist = [
              // 订单号
              [{
                // type: 'link', text: item.sequence, eventType: 'orderId', classes: ['orderId'],
                type: 'icon', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                iconSvg: `<a class="blue-cl" ${block} href="${Aurl}">${item.sequence}</a>`,
              }],
              [{
                text: item.type,
                classes: item.side === 'BUY' ? 'b-5-cl' : 'b-6-cl',
              }],
              getCoinShowName(item.coinSymbol, this.market.coinList), // 币种
              this.currentCoinPriceFix(item.price, item.coinSymbol, item.paycoin), // 价格
              fixD(item.volume, this.getFix(item.coinSymbol)), // 数量
              this.currentCoinPriceFix(item.totalPrice, item.coinSymbol, item.paycoin), // 交易额
            ];
            if (this.excheifFlag) {
              flist.push(item.relativeFee);
            }
            const Vlist = [
              item.status_text, // 状态
              // 交易对方
              item.orderType
                ? item.realName
                : [
                  {
                    type: 'html',
                    text: `<a
                      class="blue-cl"
                      style="margin-bottom: 4px;
                      width: 120px;
                      display: inline-block;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;"
                      href="javascript:;" title="${item.nickName}">
                      ${item.nickName}</a>`,
                    eventType: 'userName',
                    subContent: {
                      text: item.realName,
                      classes: ['main-cl'], // 默认没有
                    },
                  },
                ],
            ];
            flist = flist.concat(Vlist);
            list.push({
              id: JSON.stringify(item),
              data: flist,
            });
          });
          this.tabelList = list;
          this.paginationObj.total = data.data.count;
        }
      });
    },
    // 切换委托
    currentType(item) {
      if (this.nowType === item.index) { return; }
      this.nowType = item.index;
      this.paginationObj.currentPage = 1; // 页码
      this.paginationObj.total = 0; // 总条数
      this.tabelList = [];
      this.tabelLoading = true;
      this.getData();
    },
    // 切换币种
    symbolChange(item) {
      if (this.symbol === item.code) { return; }
      this.symbol = item.code;
      this.paginationObj.currentPage = 1; // 页码
      this.paginationObj.total = 0; // 总条数
      this.tabelList = [];
      this.tabelLoading = true;
      this.getData();
    },
    // 切换方向
    sideChange(item) {
      if (this.side === item.code) { return; }
      this.side = item.code;
      this.paginationObj.currentPage = 1; // 页码
      this.paginationObj.total = 0; // 总条数
      this.tabelList = [];
      this.tabelLoading = true;
      this.getData();
    },
    tableClick(type, v) {
      const data = JSON.parse(v);
      if (type === 'orderId') {
        this.$router.push(`/otcDetailOrder?orderId=${data.sequence}`);
      } else if (type === 'userName') {
        let id = '';
        if (data.side === 'BUY') {
          id = data.sellerId;
        } else if (data.side === 'SELL') {
          id = data.buyerId;
        }
        this.$router.push(`/stranger?uid=${id}`);
      }
    },
    pagechange(v) {
      this.paginationObj.currentPage = v;
      this.getData();
    },
    // 切换状态
    statusChange(item) {
      if (this.status === item.code) { return; }
      this.status = item.code;
      this.paginationObj.currentPage = 1; // 页码
      this.paginationObj.total = 0; // 总条数
      this.tabelList = [];
      this.tabelLoading = true;
      this.getData();
    },
    getStatus() {
      const url = 'order/otc/complete/statusList';
      this.axios({
        url,
        method: 'get',
      }).then((data) => {
        if (data.code.toString() === '0') {
          data.data.forEach(((item) => {
            this.statusList.push({
              code: item.status,
              value: item.statusText,
            });
          }));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-otcOrder {
  .orderId {
    margin-left: -10px !important;
  }
  .otcOrder-nav {
    height: 55px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    position: relative;
    padding-left: 32px;
    .otcOrder-nav-switchs {
      position: absolute;
      right: 20px;
      top: 20px;
      .switchWrap {
        display: inline-block;
        display: inline-block;
      }
      .text {
        font-size: 12px;
        margin-left: 10px;
        display: inline-block;
      }
    }
  }
  .otcOrder-options {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    margin-top: 14px;
    .common-select {
      display: inline-block;
      margin-right: 30px;
    }
  }
  .otcOrder-table {
    width: 100%;
    box-sizing: border-box;
    .table-head, .table-body-bar, .pagination{
      padding: 0!important;
    }
  }
}
</style>
